import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { ElementType, FormAttribute, FormComponentBase } from "../Models/Forms/FormTemplateInterfaces";

class FormsHelper {
    public static getComponentName(component: FormComponentBase, attributeName: string = null): string {
        let result = "";

        // don't display info labels?
        if (component.ElementType == ElementType.InformationLabel) return null;

        if (component.ElementType == ElementType.ScaleInput) {
            attributeName = "elementName";
        }

        try {
            let findAttributeFn = (a: FormAttribute, nameOfAttribute: string): boolean => {
                if (a.Culture == null || a.Culture.length == 0) return false;
                let isCulture = a.Culture.toLowerCase().indexOf(userLangage.toLowerCase()) > -1;
                let isName = nameOfAttribute ? a.Name == nameOfAttribute : true;
                return isCulture && isName;
            };

            let userLangage = sessionStore.userLanguageCode;
            let attribute: FormAttribute = ArrayHelper.Find(
                component.Attributes,
                (a: FormAttribute) => findAttributeFn(a, attributeName)
            );

            result = attribute.Value;

            if (component.ElementType == ElementType.ScaleInput) {
                let scaleStartAttribute: FormAttribute = ArrayHelper.Find(
                    component.Attributes,
                    (a: FormAttribute) => findAttributeFn(a, "scaleStart")
                );
                let scaleStartLabelAttribute: FormAttribute = ArrayHelper.Find(
                    component.Attributes,
                    (a: FormAttribute) => findAttributeFn(a, "scaleStartLabel")
                );
                let scaleEndAttribute: FormAttribute = ArrayHelper.Find(
                    component.Attributes,
                    (a: FormAttribute) => a.Name == "scaleEnd"
                );
                let scaleEndLabelAttribute: FormAttribute = ArrayHelper.Find(
                    component.Attributes,
                    (a: FormAttribute) => findAttributeFn(a, "scaleEndLabel")
                );

                if (scaleStartAttribute != null)
                    result += (" -  " + scaleStartAttribute.Value + " = ");
                else result += " -  1 = ";
                if (scaleStartLabelAttribute != null) result += scaleStartLabelAttribute.Value;
                if (scaleEndAttribute != null) result += (" - " + scaleEndAttribute.Value + " = ");
                if (scaleEndLabelAttribute != null) result += scaleEndLabelAttribute.Value;
            }
        }
        catch (e) {
            result = cacheStore.GetString("ComponentNameNotFoundLabel");
        }
        return result;
    }

    public static matchesCurrentUserCulture(cultureString: string): boolean {
        return cultureString.toLowerCase().indexOf(sessionStore.userLanguageCode.toLowerCase()) > -1;
    }
}

export { FormsHelper };
